<div
  [id]="id"
  role="dialog"
  tabindex="-1"
  class="kros-modal kros-modal-centered"
  [class.kros-modal-fullscreen]="isFullscreen"
  [class.kros-modal-fullscreen-mobile]="fullscreenOnMobile"
  mobileHeight
  [mobileHeightSettings]="modalMobileHeightSettings"
  (keydown.escape)="onEscapePress($event)"
>
  @if (showMobileArrowBack) {
    <div
      class="kros-modal-mobile-arrow-back"
    >
      <button
        type="button"
        class="btn btn-link arrow-back"
        aria-label="{{ 'COMMON.CLOSE' | translate }}"
        (click)="close()"
      >
        @if (newDesign) {
          <i class="hgi hgi-stroke hgi-20 hgi-arrow-left-02 arrow-back-icon"></i>
        } @else {
          <i
            class="material-icons secondary arrow-back-icon"
            aria-hidden="true"
          >
            arrow_back
          </i>
        }
      </button>
      @if (!newDesign) {
        <hr class="hr-divider" />
      }
    </div>
  }
  <div
    class="kros-modal-content kros-modal-content--empty"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="allowFocusAutocapture"
    [ngClass]="{
      'full-mobile-vertical-height': !showMobileArrowBack,
      'kros-modal-content--empty': !isContentRendered,
      'kros-modal-small-screen': smallScreenForDektop(),
      'kros-modal-content--height-ios': isIOSOrIPadOS,
    }"
    mobileHeight
    [mobileHeightSettings]="contentMobileHeightSettings"
  >
    @switch (renderMethod) {
      @case ('text') {
        <div [innerHTML]="content"></div>
      }
      @case ('template') {
        <ng-container *ngTemplateOutlet="$any(content); context: context"></ng-container>
      }
    }
    <ng-container #componentSlot></ng-container>
  </div>
</div>

@if (addGradient) {
  <div class="top-gradient"></div>
}
